import {takeEvery} from 'redux-saga/effects'

import {
  ADD_NEWS,
  DELETE_NEWS_ATTACHMENT_BY_ID,
  DELETE_NEWS_BY_ID,
  DELETE_NEWS_COVER_BY_ID,
  DELETE_NEWS_IN_BULK,
  GET_NEWS_BY_ID,
  GET_NEWS_LIST,
  NEWS_APPROVAL_INFO,
  NEWS_APPROVAL_STATUS,
  NEWS_REPORT,
  SEND_NEWS_NOTIFICATION,
  SEND_NEWS_SMS,
  UPDATE_NEWS,
} from '../../../Actions/News/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_NEWS_LIST, fetchData)
  yield takeEvery(DELETE_NEWS_BY_ID, fetchData)
  yield takeEvery(GET_NEWS_BY_ID, fetchData)
  yield takeEvery(DELETE_NEWS_IN_BULK, fetchData)
  yield takeEvery(UPDATE_NEWS, fetchData)
  yield takeEvery(ADD_NEWS, fetchData)
  yield takeEvery(NEWS_REPORT, fetchData)
  yield takeEvery(SEND_NEWS_NOTIFICATION, fetchData)
  yield takeEvery(SEND_NEWS_SMS, fetchData)
  yield takeEvery(NEWS_APPROVAL_STATUS, fetchData)
  yield takeEvery(NEWS_APPROVAL_INFO, fetchData)
  yield takeEvery(DELETE_NEWS_COVER_BY_ID, fetchData)
  yield takeEvery(DELETE_NEWS_ATTACHMENT_BY_ID, fetchData)
}

export default dataSaga
